import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon, LockIcon, FilterIcon } from 'lucide-react';
const sampleData = [{
  business: 'Manhattan Financial Partners',
  owner: 'David Rosenberg',
  title: 'Managing Partner',
  phone: '(212) 555-0192',
  email: 'david.r@manhattanfinancial.nyc',
  address: '120 Broadway, Financial District, Manhattan, NY 10271',
  website: 'manhattanfinancial.nyc',
  employees: '26-50',
  revenue: '$5M-$10M',
  specialization: 'Tax Preparation',
  borough: 'Manhattan',
  type: 'Tax Preparer',
  size: '26-50'
}, {
  business: 'Brooklyn Heights CPAs',
  owner: 'Sarah Jenkins',
  title: 'Founder & CEO',
  phone: '(718) 555-0143',
  email: 'sarah.j@brooklynheightscpa.com',
  address: '150 Court St, Brooklyn Heights, Brooklyn, NY 11201',
  website: 'brooklynheightscpa.com',
  employees: '11-25',
  revenue: '$2M-$5M',
  specialization: 'Audit Services',
  borough: 'Brooklyn',
  type: 'Audit Specialist',
  size: '11-25'
}, {
  business: 'Queens Tax & Accounting',
  owner: 'Michael Chen',
  title: 'Senior Partner',
  phone: '(718) 555-0188',
  email: 'm.chen@queenstax.net',
  address: '39-01 Main St, Flushing, Queens, NY 11354',
  website: 'queenstax.net',
  employees: '1-10',
  revenue: '$1M-$2M',
  specialization: 'Bookkeeping',
  borough: 'Queens',
  type: 'Bookkeeper',
  size: '1-10'
}, {
  business: 'Empire State Advisory',
  owner: 'Elena Rodriguez',
  title: 'Owner',
  phone: '(646) 555-0121',
  email: 'elena@empirestateadvisory.com',
  address: '350 5th Ave, Midtown Manhattan, NY 10118',
  website: 'empirestateadvisory.com',
  employees: '11-25',
  revenue: '$2M-$5M',
  specialization: 'Tax Consulting',
  borough: 'Manhattan',
  type: 'CPA Firm',
  size: '11-25'
}, {
  business: 'Staten Island Accounting Group',
  owner: "James O'Connor",
  title: 'Principal CPA',
  phone: '(718) 555-0199',
  email: 'j.oconnor@siaccounting.co',
  address: '900 South Ave, St. George, Staten Island, NY 10314',
  website: 'siaccounting.co',
  employees: '11-25',
  revenue: '$1M-$2M',
  specialization: 'Forensic Accounting',
  borough: 'Staten Island',
  type: 'Forensic Accountant',
  size: '11-25'
}, {
  business: 'Bronx Bookkeeping Pros',
  owner: 'Marcus Johnson',
  title: 'Managing Director',
  phone: '(718) 555-0177',
  email: 'marcus@bronxbookkeeping.com',
  address: '400 E Fordham Rd, Fordham, Bronx, NY 10458',
  website: 'bronxbookkeeping.com',
  employees: '1-10',
  revenue: '$500K-$1M',
  specialization: 'Small Business Bookkeeping',
  borough: 'Bronx',
  type: 'Bookkeeper',
  size: '1-10'
}, {
  business: 'SoHo Tax Advisors',
  owner: 'Amanda Lewis',
  title: 'Partner',
  phone: '(212) 555-0134',
  email: 'alewis@sohotax.nyc',
  address: '100 Spring St, SoHo, Manhattan, NY 10012',
  website: 'sohotax.nyc',
  employees: '1-10',
  revenue: '$1M-$2M',
  specialization: 'Tax Preparation',
  borough: 'Manhattan',
  type: 'Tax Preparer',
  size: '1-10'
}, {
  business: 'Williamsburg CPA Collective',
  owner: 'David Kim',
  title: 'Founder',
  phone: '(718) 555-0155',
  email: 'dkim@williamsburgcpa.com',
  address: '200 Wythe Ave, Williamsburg, Brooklyn, NY 11249',
  website: 'williamsburgcpa.com',
  employees: '11-25',
  revenue: '$2M-$5M',
  specialization: 'Startup Accounting',
  borough: 'Brooklyn',
  type: 'CPA Firm',
  size: '11-25'
}, {
  business: 'Astoria Audit Partners',
  owner: 'Maria Garcia',
  title: 'Lead Auditor',
  phone: '(718) 555-0166',
  email: 'mgarcia@astoriaaudit.net',
  address: '30-02 Broadway, Astoria, Queens, NY 11106',
  website: 'astoriaaudit.net',
  employees: '26-50',
  revenue: '$5M-$10M',
  specialization: 'Corporate Audit',
  borough: 'Queens',
  type: 'Audit Specialist',
  size: '26-50'
}, {
  business: 'Park Slope Financial',
  owner: 'Robert Taylor',
  title: 'Managing Partner',
  phone: '(718) 555-0122',
  email: 'rtaylor@parkslopefinancial.com',
  address: '150 7th Ave, Park Slope, Brooklyn, NY 11215',
  website: 'parkslopefinancial.com',
  employees: '1-10',
  revenue: '$1M-$2M',
  specialization: 'Personal Tax',
  borough: 'Brooklyn',
  type: 'Tax Preparer',
  size: '1-10'
}, {
  business: 'Midtown Corporate CPAs',
  owner: 'Jennifer Wu',
  title: 'Senior Partner',
  phone: '(212) 555-0188',
  email: 'jwu@midtowncpas.com',
  address: '200 Park Ave, Midtown Manhattan, NY 10166',
  website: 'midtowncpas.com',
  employees: '50+',
  revenue: '$10M+',
  specialization: 'Enterprise Accounting',
  borough: 'Manhattan',
  type: 'CPA Firm',
  size: '50+'
}, {
  business: 'Riverdale Forensic Accounting',
  owner: 'Thomas Brown',
  title: 'Principal',
  phone: '(718) 555-0144',
  email: 'tbrown@riverdaleforensic.com',
  address: '3700 Riverdale Ave, Riverdale, Bronx, NY 10463',
  website: 'riverdaleforensic.com',
  employees: '11-25',
  revenue: '$2M-$5M',
  specialization: 'Fraud Investigation',
  borough: 'Bronx',
  type: 'Forensic Accountant',
  size: '11-25'
}, {
  business: 'Long Island City Bookkeepers',
  owner: 'Lisa Patel',
  title: 'Owner',
  phone: '(718) 555-0133',
  email: 'lpatel@licbookkeepers.net',
  address: '10-20 50th Ave, Long Island City, Queens, NY 11101',
  website: 'licbookkeepers.net',
  employees: '1-10',
  revenue: '$500K-$1M',
  specialization: 'E-commerce Bookkeeping',
  borough: 'Queens',
  type: 'Bookkeeper',
  size: '1-10'
}, {
  business: 'Tribeca Tax & Audit',
  owner: 'William Clark',
  title: 'Managing Director',
  phone: '(212) 555-0111',
  email: 'wclark@tribecatax.com',
  address: '100 Duane St, Tribeca, Manhattan, NY 10007',
  website: 'tribecatax.com',
  employees: '26-50',
  revenue: '$5M-$10M',
  specialization: 'Corporate Tax',
  borough: 'Manhattan',
  type: 'Audit Specialist',
  size: '26-50'
}, {
  business: 'DUMBO Financial Group',
  owner: 'Rachel Green',
  title: 'Partner',
  phone: '(718) 555-0190',
  email: 'rgreen@dumbofinancial.com',
  address: '55 Water St, DUMBO, Brooklyn, NY 11201',
  website: 'dumbofinancial.com',
  employees: '11-25',
  revenue: '$2M-$5M',
  specialization: 'Tech Startup Accounting',
  borough: 'Brooklyn',
  type: 'CPA Firm',
  size: '11-25'
}];
export function NYCAccountingDataPreview() {
  const [activeRow, setActiveRow] = useState<number | null>(null);
  const [boroughFilter, setBoroughFilter] = useState('All');
  const [typeFilter, setTypeFilter] = useState('All');
  const [sizeFilter, setSizeFilter] = useState('All');
  const filteredData = useMemo(() => {
    return sampleData.filter(item => {
      if (boroughFilter !== 'All' && item.borough !== boroughFilter) return false;
      if (typeFilter !== 'All' && item.type !== typeFilter) return false;
      if (sizeFilter !== 'All' && item.size !== sizeFilter) return false;
      return true;
    });
  }, [boroughFilter, typeFilter, sizeFilter]);
  return <section className="py-24 bg-white" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-64">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-65">
            Preview the NYC CPA & accounting firm owner database
          </h2>
          <p className="text-xl text-slate-600" data-id="element-66">
            Filter by borough, firm type, and size. Our New York City accounting
            email list includes verified local business owner contacts for CPAs,
            tax preparers, bookkeepers, and forensic accountants.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-xl overflow-hidden" data-id="element-67">
          <div className="p-6 border-b border-slate-200 bg-slate-50 space-y-4" data-id="element-68">
            <div className="flex flex-wrap items-center gap-3" data-id="element-69">
              <div className="flex items-center gap-2 mr-auto" data-id="element-70">
                <FilterIcon className="w-5 h-5 text-slate-400" data-id="element-71" />
                <h3 className="text-lg font-bold text-slate-900 whitespace-nowrap" data-id="element-72">
                  Filter NYC local businesses
                </h3>
              </div>

              <select className="bg-white border border-slate-300 text-slate-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 shadow-sm" value={boroughFilter} onChange={e => setBoroughFilter(e.target.value)} data-id="element-73">
                <option value="All" data-id="element-74">All Boroughs</option>
                <option value="Manhattan" data-id="element-75">Manhattan</option>
                <option value="Brooklyn" data-id="element-76">Brooklyn</option>
                <option value="Queens" data-id="element-77">Queens</option>
                <option value="Bronx" data-id="element-78">Bronx</option>
                <option value="Staten Island" data-id="element-79">Staten Island</option>
              </select>

              <select className="bg-white border border-slate-300 text-slate-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 shadow-sm" value={typeFilter} onChange={e => setTypeFilter(e.target.value)} data-id="element-80">
                <option value="All" data-id="element-81">All Firm Types</option>
                <option value="CPA Firm" data-id="element-82">CPA Firm</option>
                <option value="Tax Preparer" data-id="element-83">Tax Preparer</option>
                <option value="Bookkeeper" data-id="element-84">Bookkeeper</option>
                <option value="Forensic Accountant" data-id="element-85">Forensic Accountant</option>
                <option value="Audit Specialist" data-id="element-86">Audit Specialist</option>
              </select>

              <select className="bg-white border border-slate-300 text-slate-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 shadow-sm" value={sizeFilter} onChange={e => setSizeFilter(e.target.value)} data-id="element-87">
                <option value="All" data-id="element-88">All Sizes</option>
                <option value="1-10" data-id="element-89">1-10 Employees</option>
                <option value="11-25" data-id="element-90">11-25 Employees</option>
                <option value="26-50" data-id="element-91">26-50 Employees</option>
                <option value="50+" data-id="element-92">50+ Employees</option>
              </select>

              {(boroughFilter !== 'All' || typeFilter !== 'All' || sizeFilter !== 'All') && <button onClick={() => {
              setBoroughFilter('All');
              setTypeFilter('All');
              setSizeFilter('All');
            }} className="text-xs font-medium text-slate-500 hover:text-slate-700 transition-colors underline underline-offset-2" data-id="element-93">
                  Clear all
                </button>}
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-94">
            <table className="w-full text-sm text-left" data-id="element-95">
              <thead data-id="element-96">
                <tr className="text-slate-500 font-semibold border-b border-slate-200 bg-slate-50/50" data-id="element-97">
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-98">Business name</th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-99">
                    Verified owner / contact
                  </th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-100">Title</th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-101">
                    <div className="flex items-center gap-2" data-id="element-102">
                      Email
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-700" data-id="element-103">
                        Verified
                      </span>
                    </div>
                  </th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-104">
                    <div className="flex items-center gap-2" data-id="element-105">
                      Phone
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-700" data-id="element-106">
                        Verified
                      </span>
                    </div>
                  </th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-107">Address</th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-108">Firm Type</th>
                  <th className="py-4 px-4 whitespace-nowrap" data-id="element-109">Employees</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-110">
                {filteredData.length > 0 ? filteredData.map((row, idx) => {
                const isBlurred = idx >= 3;
                return <motion.tr key={idx} onHoverStart={() => !isBlurred && setActiveRow(idx)} onHoverEnd={() => !isBlurred && setActiveRow(null)} className={`transition-all duration-200 ${isBlurred ? 'bg-slate-50/50 select-none' : 'cursor-pointer'} ${activeRow === idx && !isBlurred ? 'bg-blue-50' : !isBlurred ? 'hover:bg-slate-50' : ''}`} data-id="element-111">
                        <td className="py-4 px-4 font-semibold text-slate-900 whitespace-nowrap" data-id="element-112">
                          {row.business}
                        </td>
                        <td className="py-4 px-4 text-slate-600 whitespace-nowrap" data-id="element-113">
                          {row.owner}
                        </td>
                        <td className="py-4 px-4 text-slate-500 whitespace-nowrap" data-id="element-114">
                          {row.title}
                        </td>
                        <td className="py-4 px-4 whitespace-nowrap relative" data-id="element-115">
                          {isBlurred ? <div className="flex items-center justify-center absolute inset-0 bg-white/40 backdrop-blur-[4px] z-10" data-id="element-116">
                              <LockIcon className="w-4 h-4 text-slate-400" data-id="element-117" />
                            </div> : null}
                          <div className={`flex items-center gap-1.5 ${isBlurred ? 'opacity-30' : ''}`} data-id="element-118">
                            <ShieldCheckIcon className="w-3.5 h-3.5 text-green-600 flex-shrink-0" data-id="element-119" />
                            <span className="text-blue-600 font-medium" data-id="element-120">
                              {row.email}
                            </span>
                          </div>
                        </td>
                        <td className="py-4 px-4 whitespace-nowrap relative" data-id="element-121">
                          {isBlurred ? <div className="flex items-center justify-center absolute inset-0 bg-white/40 backdrop-blur-[4px] z-10" data-id="element-122">
                              <LockIcon className="w-4 h-4 text-slate-400" data-id="element-123" />
                            </div> : null}
                          <div className={`flex items-center gap-1.5 text-slate-600 ${isBlurred ? 'opacity-30' : ''}`} data-id="element-124">
                            <ShieldCheckIcon className="w-3.5 h-3.5 text-green-600 flex-shrink-0" data-id="element-125" />
                            <span data-id="element-126">{row.phone}</span>
                          </div>
                        </td>
                        <td className="py-4 px-4 text-slate-600 whitespace-nowrap" data-id="element-127">
                          {row.address}
                        </td>
                        <td className="py-4 px-4 text-slate-600 whitespace-nowrap" data-id="element-128">
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-129">
                            {row.type}
                          </span>
                        </td>
                        <td className="py-4 px-4 text-slate-600 whitespace-nowrap" data-id="element-130">
                          {row.employees}
                        </td>
                      </motion.tr>;
              }) : <tr data-id="element-131">
                    <td colSpan={8} className="py-12 text-center text-slate-500" data-id="element-132">
                      No accounting firms found matching your filters. Try
                      adjusting your criteria.
                    </td>
                  </tr>}
              </tbody>
            </table>
          </div>

          <div className="p-4 bg-slate-50 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-133">
            <p className="text-sm text-slate-500" data-id="element-134">
              Showing {filteredData.length} of{' '}
              <strong className="text-slate-900" data-id="element-135">3,450+</strong> verified NYC
              accounting firm records.
            </p>
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors" data-id="element-136">
              <DownloadIcon className="w-4 h-4" data-id="element-137" />
              Unlock full database
            </a>
          </div>
        </div>
      </div>
    </section>;
}